module.exports = __webpack_public_path__ + "static/media/ubuntu.88ee9aa8.svg";